import moment from "moment";

export const setConnected = (lastUpdate) => {
  if (lastUpdate) {
    return (
      moment(lastUpdate, "YYYY-MM-DDTHH:mm:ss.SSSSZ").diff(
        moment(),
        "minutes",
      ) > -1
    );
  }
  return false;
};
